import React from 'react';
import c from '../w.js';

const IconChevronUpSmall = React.memo(
  c(
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 10.4141L6.70712 15.707L5.29291 14.2928L12 7.58569L18.7071 14.2928L17.2929 15.707L12 10.4141Z"
      }
    )
  )
);

export { IconChevronUpSmall };
